import { useState, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useToast, Stack, H2, Toaster } from '@kinesis/bungle';
import { Layout } from '@/components/layout';
import { FeedbackForm } from '@/components/feedback-form';
import { useSubmitFeedbackMutation } from '@/api/feedback';

const Feedback = () => {
  const toast = useToast('globalTop');
  const [searchParams] = useSearchParams();
  const defaultProduct = searchParams.get('product') ?? undefined;
  const [submitFeedback, { isLoading }] = useSubmitFeedbackMutation();
  const [key, setKey] = useState(0);

  const onSubmit = useCallback(
    async (value: {
      product: string;
      productLabel: string;
      category: string;
      description: string;
    }) => {
      try {
        await submitFeedback(value).unwrap();
        toast('Thank you! Your feedback has been submitted.', {
          variant: 'success',
        });
        setKey((k) => k + 1);
      } catch {
        toast('We couldn\u2019t submit your feedback. Please try again.', {
          variant: 'error',
        });
      }
    },
    [submitFeedback, toast],
  );

  return (
    <Layout variant='narrow'>
      <Toaster id='globalTop' placement='top' />
      <Stack space='large'>
        <H2>Feedback</H2>
        <FeedbackForm
          key={key}
          defaultProduct={defaultProduct}
          onSubmit={onSubmit}
          isSubmitting={isLoading}
        />
      </Stack>
    </Layout>
  );
};

export { Feedback };
